import useFetch from 'syf-api/api/useFetch';
import { trendsUrl } from '../../services/spending-trends/spending-trends-api';
export var trendsQueryCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType, statementDate = _a.statementDate;
    return [trendsUrl, { accountId: accountId, accountIdType: accountIdType, statementDate: statementDate }];
};
export var trendsQuery = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config, statementDate = _a.statementDate;
    return function () {
        var fetchWrapper = useFetch(config);
        var params = new URLSearchParams({
            'cipher.accountId': accountId
        });
        if (accountIdType) {
            params.set('accountIdType', accountIdType);
        }
        if (statementDate === null || statementDate === void 0 ? void 0 : statementDate.match(/^\d{4}-\d{2}-\d{2}$/)) {
            params.set('statementDate', statementDate);
        }
        return fetchWrapper("".concat(trendsUrl, "?").concat(params), {
            method: 'GET'
        });
    };
};
//# sourceMappingURL=trends-query.js.map